import { Redirect, Route, Switch } from "react-router-dom";
import { AgentProfile, AgentProfileUpdate } from "../../../AgentProfile";
import JobDescription from "@/containers/AgentProfile/JobDescription";
import UpdateCertificate from "@/containers/AgentProfile/UpdateCertificate";
import LunchList from "@/containers/Attendance/LunchList";

export default () => {
  const token = localStorage?.getItem("token");

  return (
    <Switch>
      <Route path="/profile/info" component={AgentProfile} />
      {/* <Route
        path="/profile/info/:id"
        render={(routeProps) => <AgentProfile {...routeProps} />}
      /> */}

      <Route path="/profile/update" component={AgentProfileUpdate} />
      <Route
        path="/profile/job-description/:id"
        render={(routeProps) => <JobDescription {...routeProps} />}
      />
      <Route
        path="/profile/document/:id"
        render={(routeProps) => <UpdateCertificate {...routeProps} />}
      />
      <Route path="/profile/lunch" component={LunchList} />
      {/* <Route path="/profile/new-request" component={RequestForm} />
      <Route path="/profile/id" component={RequestDetails} /> */}
      <Route
        exact
        path="/account/generic_info"
        render={() =>
          token !== null ? <GenericInfo /> : <Redirect to="/log_in" />
        }
      />
    </Switch>
  );
};
